import { render, staticRenderFns } from "./ActivitySelectBox.vue?vue&type=template&id=54681726&scoped=true&"
import script from "./ActivitySelectBox.vue?vue&type=script&lang=js&"
export * from "./ActivitySelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54681726",
  null
  
)

export default component.exports